import React from "react";

export default function LaborMetricPair({ items, compact = false }) {
  return (
    <dl className={`my-3 grid ${items.length > 1 ? "grid-cols-2" : "grid-cols-1"} gap-4`}>
      {items.map(({ label, value }, index) => (
        <div key={label} className={`min-w-0 ${index > 0 ? "border-l border-slate-200 pl-4" : ""}`}>
          <dt className="text-xs font-medium text-slate-500">{label}</dt>
          <dd className={`mt-1 font-semibold tracking-tight tabular-nums text-slate-950 ${compact ? "text-xl" : "text-2xl"}`}>
            {value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
